export default __webpack_public_path__ + "static/media/Logo_Avempace_2018.80cb6e34.png";